import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { deepOrange, red} from '@material-ui/core/colors';
import { AppBar,Button,Typography,Toolbar,Grid,Card,CardHeader,Avatar,CardContent,Container,Box,Backdrop,CircularProgress,Dialog,DialogTitle,DialogActions,DialogContent,DialogContentText,Snackbar, Divider,MenuItem,Menu} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';


import Skeleton from '@material-ui/lab/Skeleton';
import MuiAlert from '@material-ui/lab/Alert';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import {useLocation} from "react-router-dom";
import Lang from "./Lang";
import useUserLang from "./useUserLang";
import { CalendarTodayOutlined} from "@material-ui/icons";
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
//TODO: handle running out of seats

function ExamsController() {
    const [apiResponse, setApiResponse] = useState({});
    const [stage, setStage] = useState("");
    const [person,setPerson]=useState({});
    const [dates,setDates]=useState([]);
    const [uid, setUid] = useState("");
    const location = useLocation();
    const {userLang,changeUserLang}=useUserLang();
    const apiDomain=(process.env.NODE_ENV!=="development"?"/api":"http://"+window.location.hostname+":9000/api")
    const [loading,setLoading]=useState(false);
    const [loadingPerson,setLoadingPerson]=useState(false);
    const [error,setError]=useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("Success");
    const [modalMessage, setModalMessage] = useState("");
    const [modalNote, setModalNote] = useState("");
    const [modalType, setModalType] = useState("");
    
    const [bookDateCode,setBookDateCode]=useState("");
    const [bookDateTime,setBookDateTime]=useState("");
    
    const [snackbarOpen,setSnackbarOpen]=useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarType, setSnackbarType] = useState("success");
    const useStyles = makeStyles((theme)=>({
        orange: {
            color: theme.palette.getContrastText(deepOrange[500]),
            backgroundColor: deepOrange[500],
          },
          cardRood: {
            maxWidth: 395,
          },
          personalDetails:{
              fontSize:14
          },
          backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
          },
    })

    );
    const classes = useStyles();
    useEffect(()=>{
        const uidParams = new URLSearchParams(location.search).get("uid");
        if(uidParams&&uidParams!==uid){
            setUid(uidParams);
        }else if (!uidParams){
            setUid("");
        }
        
        //apiDomain=location.pathname;
    },[location]);

    useEffect(()=>{
        if(uid&&uid!==""){
            setStage("examdates");
            setLoadingPerson(true);
            callAPI("/exams/getexamsdates/"+uid+"/?");
        }else{
            setPerson({});
            setDates([]);
        }
    },[uid]);
  
    useEffect(()=>{
        //console.log(apiResponse);
        if(apiResponse.data){
            if(apiResponse.data.person){
                setPerson(apiResponse.data.person);
            }
            if(apiResponse.data.dates){
                setDates(apiResponse.data.dates);
            }
        }
        if(apiResponse.success){
            setSnackbarType("success");
            if(stage==="bookDate"){
                setSnackbarMessage(Lang[userLang].registersuccess+" "+bookDateTime);
                setSnackbarOpen(true);    
            }else if(stage==="unbookDate"){
                setSnackbarMessage(Lang[userLang].unregistersuccess+" "+bookDateTime);
                setSnackbarOpen(true);
            }
        }else{
            setSnackbarType("error");
            setSnackbarMessage(apiResponse.message);
            if(stage==="examdates"){
                setPerson({});
                setDates([]);
            }else if (stage==="bookDate"){
                setSnackbarOpen(true);
            }else if(stage==="unbookDate"){
                setSnackbarOpen(true);
            }
         
        }
        setLoading(false);
        setLoadingPerson(false);
    },[apiResponse])

      const callAPI=(params)=> {
        //console.log("API being called with params:"+JSON.stringify(params));
        setError("");
        fetch(apiDomain+params)
            .then(res => res.text())
            .then(res => setApiResponse(JSON.parse(res) ))
            .catch((error)=>{
                console.log("error with API call");
                console.log(error);
                setLoading(false);
                setError(error.message);
            });
        }       
        const bookDateConfirm=(dateCode,dateTimeText)=>{
            setModalType("bookDate");
            setModalTitle(Lang[userLang].confirmation);
            setModalMessage(Lang[userLang].confexaminedon+" "+dateTimeText);
            setModalNote(Lang[userLang].confexaminedonnote);
            setBookDateCode(dateCode);
            setBookDateTime(dateTimeText);
            setModalOpen(true);
        }
        const bookDate=()=>{
            const dateCode=bookDateCode;
            setModalOpen(false);
            setLoading(true);
            setStage("bookDate");
            callAPI("/exams/register/"+uid+"/"+dateCode+"?");
        }
        const unbookDateConfirm=(dateCode,dateTimeText)=>{
            setModalType("unbookDate");
            setModalTitle(Lang[userLang].confirmation);
            setModalMessage(Lang[userLang].confunregisterfrom+" "+dateTimeText);
            setModalNote("");
            setBookDateCode(dateCode);
            setBookDateTime(dateTimeText);
            setModalOpen(true);
        }

        const unbookDate=()=>{
            const dateCode=bookDateCode;
            setModalOpen(false);
            setLoading(true);
            setStage("unbookDate");
            callAPI("/exams/unregister/"+uid+"/"+dateCode+"?");
        }
        const closeModal=()=>{
            setModalOpen(false);
        }
        
        const PersonInfo=((props)=> {
            const person=props.person;
            const dates=props.dates;
            const loading=props.loading;
            const countDates=dates.length;
            const canBook=!person.examined&&!person.planned;
            const canUnbook=!person.examined&&person.planned;
            const statusText=person.examined?Lang[userLang].examined:(person.planned?Lang[userLang].registeredfor+" ":Lang[userLang].notregisteredfor);
            const statusText2=!person.examined&&person.planned?excelDate(person.plannedExamDate,false,userLang)+" "+localisedTime(person.plannedExamTime,userLang):"";
            const personalInfo="Id# 12345";
            const licenseText=Lang[userLang].license+"#: "+person.licenseNo;
            const licenseText2=Lang[userLang].expires+": "+excelDate(person.licenseExpiration,true,userLang);
            return <>
            <Container> {/**xl */}
                <SectionHeading title={Lang[userLang].personaldetails}/>
                <Card className={classes.cardRoot}>
                    <CardHeader
                        avatar={
                        loading?<Skeleton animation="wave" variant="circle" width={40} height={40} />:<Avatar className={classes.orange}>SI</Avatar>
                        }
                        title={loading?<Skeleton animation="wave"/>:person.fullName}
                        subheader={loading?<Skeleton animation="wave"/>:<><Box>{licenseText}</Box>{licenseText2}</>}
                    />
                </Card>
                <Box height="50%">&nbsp;</Box>    
                <SectionHeading title={Lang[userLang].status}/>
                <Card className={classes.cardRoot}>
                    <CardContent>
                        <div style={{margin:20}}>
                        {/* <Typography color="textPrimary">{loading?<Skeleton/>:"Status:"}</Typography>*/}
                        <Typography color="primary">{loading?<Skeleton/>:statusText}</Typography>
                        <Typography color="primary">{loading?<Skeleton/>:statusText2}</Typography>
                        </div>
                        {!loading&&person.fullName&&person.planned&&!person.examined&&<>
                        <Divider variant="middle" />
                        <div style={{margin:20}}>
                            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
                                <Grid item><ErrorOutlineIcon fontSize="large" color="primary"/></Grid>
                                <Grid item xs={10}>
                                    <p style={{lineHeight:1.5,marginTop:0,marginBottom:0}}>
                                    {Lang[userLang].instructionsprefix}<br></br>
                         <a href='https://www.nicosiasailingclub.com/speed-boat-exams-instructions' target='_blank'>{Lang[userLang].instructions}</a>
                                    </p>
                                </Grid>
                            </Grid>
                        </div>
                        </>}
                    </CardContent>
                </Card>
            </Container>
            <Box height="50%">&nbsp;</Box>
            {!loading&&
            <Container>{/**xl */}
                {canBook&&countDates===0&&<NoDatesPanel userLang={userLang}/>}
                {(canBook&&countDates>0)&&<ActionPanel bookDateHandler={bookDateConfirm} dates={dates} userLang={userLang}></ActionPanel>}
                {canUnbook&&<UnregisterPanel unBookDateHandler={unbookDateConfirm} userLang={userLang} person={person}></UnregisterPanel>}
            </Container>}
            </>
        });    
        
 

    return <>
    <Backdrop className={classes.backdrop} open={loading}><CircularProgress color="inherit" /></Backdrop>
    <ConfirmDialog open={modalOpen} title={modalTitle} message={modalMessage} note={modalNote} handleYes={modalType==="bookDate"?bookDate:unbookDate} handleNo={closeModal} userLang={userLang}></ConfirmDialog>
    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={()=>setSnackbarOpen(false)} anchorOrigin={{vertical:'bottom',horizontal:'center'}}>
        <Alert  severity={snackbarType}>{snackbarMessage}</Alert>
    </Snackbar>
    
    
    <PageHeader Lang={Lang} userLang={userLang} languageChangeHandler={changeUserLang}/>
    <Box height="50%">&nbsp;</Box>
    <Grid container direction="column" justify="center">
        <Grid spacing={1}>
            <Grid item>
            {uid===""&&<EmptyMessagePanel message={Lang[userLang].clickonsmslink}/>}
            {uid!==""&&(loadingPerson || (!loadingPerson&&person.fullName))&&<PersonInfo person={person} dates={dates} loading={loadingPerson}></PersonInfo>}
            {uid!==""&&!loadingPerson&&!person.fullName&&(loading?"":<EmptyMessagePanel message={Lang[userLang].usernotfound}/>)}
            {!error===""&&<EmptyMessagePanel message="{error}"/>}
            </Grid>
            <Grid item>
                <PageFooter person={person} uid={uid} userLang={userLang} loading={loadingPerson} languageChangeHandler={changeUserLang}/>
            </Grid>
        </Grid>
    </Grid>
    
    </>;
  }
  const SectionHeading=((props)=>{
      const {title}=props;
      return <>
    <div style={{margin:10}}>
    <Typography variant="h8" style={{color:"gray"}}>{title}</Typography>
    </div>
    </>
  })
  const ConfirmDialog=((props)=>{
    const {open,title,message,note,handleYes,handleNo,userLang}=props;
    const handleOK=()=>{
        handleYes();
    }
    return <>
    <Dialog
        open={open}
      >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {note&&<p style={{color:"red"}}>{note}</p>}
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleNo} color="default">
          {Lang[userLang].no}
          </Button>
          <Button onClick={handleOK} color="primary" autoFocus>
          {Lang[userLang].yes}
          </Button>
        </DialogActions>
      </Dialog>
      </>
  })

  const Alert=((props)=> {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  })

  const ActionPanel=((props)=>{
    const {dates,bookDateHandler,userLang}=props;
    return <>
    <SectionHeading title={Lang[userLang].nextaction}/>
    <Card><CardContent>
    <p  style={{lineHeight:1.5,margin:0}}>{Lang[userLang].registertobeexamined}:</p>
    <List>
        {dates.map((item,key)=>{
        const keyText=excelDate(item.date,false,userLang)+" "+localisedTime(item.time,userLang);
        const availableSeatsText=Lang[userLang].availableseats+": "+item.availableSeats;
            return <>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <CalendarTodayOutlined/>
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={<><Box maxWidth={150}>{keyText}</Box></>} secondary={availableSeatsText}/>
                    <ListItemSecondaryAction>
                        <Button color="primary" variant="contained" size="small" onClick={() => bookDateHandler(item.code,keyText)}>{Lang[userLang].register}</Button>
                    </ListItemSecondaryAction>
                </ListItem>
            </>})}
            </List>
    </CardContent></Card>
    
    </>
  })

  const UnregisterPanel=((props)=>{
    const {unBookDateHandler,userLang,person}=props;
    const keyText=excelDate(person.plannedExamDate,false,userLang)+" "+localisedTime(person.plannedExamTime,userLang);
    return <>
    <SectionHeading title={Lang[userLang].cantmakeit}/>
    <Card>
        <CardContent>
            <p style={{lineHeight:1.5,marginTop:0}}>{Lang[userLang].cantmakeittext}</p>
            <Button size="medium" variant="contained" color="secondary" onClick={() => unBookDateHandler(person.plannedExamCode,keyText)}>{Lang[userLang].unregister}</Button>
        </CardContent>
    </Card>
    </>
  })
  const NoDatesPanel=((props)=>{
      const {userLang}=props;
    return <>
    <Card>
        <CardContent>
            <Typography variant="h6">{Lang[userLang].nodates}</Typography>
            <p>{Lang[userLang].nodatestext}</p>
        </CardContent>
    </Card>
    </>
  })
  const excelDate=(date,short,userLang)=>{
    const newDate=new Date((date - (25567 + 2))*86400*1000);
    const locale=userLang==="en"?"en-US":"el-GR";
    const dayName=newDate.toLocaleString(locale, {weekday: 'short'});
    const monthName=newDate.toLocaleString(locale, {month: 'short'});
    const month=newDate.getMonth()+1;
    if(short){
        return newDate.getDate()+"/"+month+"/"+newDate.getFullYear();
    }else{
        return dayName+", "+newDate.getDate()+" "+monthName+" "+newDate.getFullYear();
    }
}
const localisedTime=(time,userLang)=>{
    let rValue=time;
    if(userLang==="en"){
        rValue=rValue.replace("πμ","am").replace("μμ","pm");
    }else{
        rValue=rValue.replace("am","πμ").replace("pm","μμ");
    }
    return rValue;
}

const EmptyMessagePanel=((props)=>{
    const {message}=props;
    return <>
      <Grid container alignItems="center" justify="center" direction="row">
          <Grid item style={{padding:20,textAlign:"center"}}>
          <Typography variant="h5">{message}</Typography>
          </Grid>
      </Grid></>
});


  const PageHeader=((props)=>{
      const {Lang,userLang}=props;
    return <>
    <AppBar position="static">
        <Toolbar style={{padding:10}}>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
            <Grid item>
                <img src="icon.png" alt="Nicosia Sailing Club logo"></img>
            </Grid>
            <Grid item xs={9}>
                <Typography variant="h7">{Lang[userLang].nsl}</Typography>
                <Box/>
                <Typography variant="h8">{Lang[userLang].intro}</Typography>
            </Grid>
        </Grid>
        </Toolbar>
    </AppBar>

    </>
  });

  const PageFooter=((props)=>{
      const {person,uid,userLang,languageChangeHandler}=props;
      const [anchorEl, setAnchorEl] = React.useState(null);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
      const handleClose = (newlang) => {
        setAnchorEl(null);
        if(newlang==="gr"||newlang==="en"){
            languageChangeHandler(newlang);
        }
      };
      return <>
        <Grid container alignItems="center" justify="center" direction="column">
            <Grid item>
                <div style={{textAlign:"center",margin:15}}>
                <p  style={{lineHeight:1.4}}>
                {Lang[userLang].moreinfoemail}: <a href="mailto:boatexams@nicosiasailingclub.com">boatexams@nicosiasailingclub.com</a><br/>
                {Lang[userLang].orvisitwebsite} <a href="https://nicosiasailingclub.com" target="_blank">nicosiasailingclub.com</a>
                </p>
                </div>
            </Grid>
            <Grid item>
                  <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} variant="text" size="small"
                  color="default" disableElevation
                  endIcon={<ExpandMoreOutlinedIcon/>}>
                    {userLang==="gr"?"Ελληνικα":"English"}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={()=>handleClose("en")}>English</MenuItem>
                    <MenuItem onClick={()=>handleClose("gr")}>Ελληνικά</MenuItem>
                </Menu>

            </Grid>
        </Grid>
        <Box height="50%">&nbsp;</Box>
        
       {/*

      <Box height="50%">&nbsp;</Box>
      <Container maxWidth="xs">
      <ToggleButtonGroup value={userLang}>
          <ToggleButton value={"en"}>English</ToggleButton>
          <ToggleButton value={"gr"}>Ελληνικά</ToggleButton>
      </ToggleButtonGroup>
      </Container>

      <p>
      [<Link to={"./?lang=en&uid="+uid} className="ui button">English</Link>]&nbsp;
      [<Link to={"./?lang=gr&uid="+uid} className="ui button">Eλληνικά</Link>]
      </p>
      <p>
      Test links:
      <Link to="./">Nolang</Link>
      [ <Link to="./?uid=11223344">11223344</Link> ]
      [ <Link to="./?uid=aabbcc">aabbcc</Link> ]
      [ <Link to="./?uid=948cb1bd534cda4781cf153f70c1482b">948cb1bd534cda4781cf153f70c1482b</Link> ]
      [ <Link to="./=">clear UID</Link> ]
      </p>
       */}
      </>
  });

  export default ExamsController;

